export const HOME_QUOTES: string[] = [
  "We build the future, not just structures.",
  "Excellence is not a skill, it’s an attitude.",
  "Prepare and prevent, don’t repair and repent.",
  "Coming together is a beginning, keeping together is progress, working together is success.",
  "None of us is as smart as all of us.",
  "Don’t watch the clock; do what it does. Keep going.",
  "A pile of rocks ceases to be a rock pile when somebody contemplates it with the idea of a cathedral.",
  "Pleasure in the job puts perfection in the work.",
  "Measure twice, cut once.",
  "Every job is a self-portrait of the person who did it. Autograph your work with excellence.",
  "The best safety device is a careful worker.",
  "Don't learn safety by accident.",
  "Tomorrow: Your reward for working safely today.",
  "Rome wasn’t built in a day, but they were laying bricks every hour.",
  "We shape our buildings; thereafter they shape us.",
  "The person who says it cannot be done should not interrupt the person who is doing it.",
    "The unexamined life is not worth living.",
    "Man is the measure of all things.",
    "The journey of a thousand miles begins with one step.",
    "Honesty is the first chapter in the book of wisdom.",
    "Better to remain silent and be thought a fool than to speak and to remove all doubt.",
    "Peace is not absence of conflict, it is the ability to handle conflict by peaceful means.",
    "All animals are equal, but some animals are more equal than others.",
    "Law is order, and good law is good order.",
    "Houston, we have a problem.",
    "Keep your friends close, but your enemies closer.",
    "Life is like a box of chocolates. You never know what you’re gonna get.",
    "Knowledge is power.",
    "Success usually comes to those who are too busy to be looking for it.",
    "An investment in knowledge pays the best interest.",
    "Eighty percent of success is showing up.",
    "Genius is one percent inspiration and ninety-nine percent perspiration.",
    "Keep your face always toward the sunshine — and shadows will fall behind you.",
    "Anyone who stops learning is old, whether at twenty or eighty.",
    "We don’t stop playing because we grow old; we grow old because we stop playing.",
    "Youth would be an ideal state if it came a little later in life.",
    "Better to remain silent and be thought a fool than to speak and to remove all doubt.",
    "Do not dwell in the past, do not dream of the future, concentrate the mind on the present moment.",
    "Life is what happens when you’re busy making other plans.",
    "Be yourself; everyone else is already taken.",
    "Two things are infinite: the universe and human stupidity; and I’m not sure about the universe.",
    "Not everything that is faced can be changed, but nothing can be changed until it is faced.",
    "Education is the most powerful weapon which you can use to change the world.",
    "Success is not final, failure is not fatal: It is the courage to continue that counts.",
    "Don’t count the days, make the days count.",
    "Strive not to be a success, but rather to be of value.",
    "In war, truth is the first casualty.",
    "Behind every great man is a woman rolling her eyes.",
    "Age is an issue of mind over matter. If you don’t mind, it doesn’t matter.",
    "Always borrow money from a pessimist. He won’t expect it back.",
    "Outside of a dog, a book is man’s best friend. Inside of a dog it’s too dark to read.",
    "Go to Heaven for the climate, Hell for the company.",
    "Clothes make the man. Naked people have little or no influence on society.",
    "Get your facts first, then you can distort them as you please.",
    "Be careful about reading health books. You may die of a misprint.",
    "Behind every successful man is a surprised woman.",
    "Some cause happiness wherever they go; others whenever they go.",
    "Better to remain silent and be thought a fool than to speak out and remove all doubt.",
    "Do not go where the path may lead, go instead where there is no path and leave a trail.",
    "The best way to predict the future is to invent it.",
    "The function of leadership is to produce more leaders, not more followers.",
    "Management is doing things right; leadership is doing the right things.",
    "Business opportunities are like buses; there’s always another one coming.",
    "Price is what you pay. Value is what you get.",
    "Your most unhappy customers are your greatest source of learning.",
    "Success is not the key to happiness. Happiness is the key to success.",
    "You miss 100% of the shots you don’t take.",
    "Champions keep playing until they get it right.",
    "Hard work beats talent when talent doesn’t work hard.",
    "Science is organized knowledge. Wisdom is organized life.",
    "Equipped with his five senses, man explores the universe around him and calls the adventure Science.",
    "Faith is taking the first step even when you don’t see the whole staircase.",
    "Art washes away from the soul the dust of everyday life.",
    "Every artist was first an amateur.",
    "Sports do not build character. They reveal it.",
    "Success is where preparation and opportunity meet.",
    "Don’t measure yourself by what you have accomplished, but by what you should have accomplished with your ability.",
    "Great minds discuss ideas; average minds discuss events; small minds discuss people.",
    "Leadership is not about being in charge. It is about taking care of those in your charge.",
    "Quality is not an act, it is a habit.",
    "Success is walking from failure to failure with no loss of enthusiasm.",
    "Failure is simply the opportunity to begin again, this time more intelligently.",
    "Don’t measure yourself by what you have accomplished, but by what you should have accomplished with your ability.",
    "Logic will get you from A to B. Imagination will take you everywhere.",
    "The true sign of intelligence is not knowledge but imagination.",
    "Business opportunities are like buses; there’s always another one coming.",
];

// Optional TR pool for language switch on /home.
// EN remains the original/source language.
export const HOME_QUOTES_TR: string[] = [
  'Geleceği sadece yapılar değil, birlikte inşa ederiz.',
  'Mükemmellik bir beceri değil, bir tutumdur.',
  'Hazırlan ve önle; tamir edip pişman olma.',
  'Bir araya gelmek başlangıçtır; birlikte kalmak ilerlemedir; birlikte çalışmak başarıdır.',
  'Hiçbirimiz hepimiz kadar akıllı değiliz.',
  'Saate bakma; onun yaptığını yap. Devam et.',
  'Taş yığını, birisi onu bir katedral fikriyle düşündüğünde taş yığını olmaktan çıkar.',
  'İşte zevk, işte mükemmelliği getirir.',
  'İki kez ölç, bir kez kes.',
  'Her iş, yapan kişinin otoportresidir. İşini mükemmellikle imzala.',
  'En iyi güvenlik cihazı, dikkatli bir çalışandır.',
  'Güvenliği kazayla öğrenme.',
  'Yarın: Bugün güvenli çalışmanın ödülü.',
  'Roma bir günde inşa edilmedi; ama her saat tuğla döşediyorlardı.',
  'Binaları biz şekillendiririz; sonra onlar bizi şekillendirir.',
  'Yapılamaz diyen kişi, yapan kişinin sözünü kesmemeli.',
];

